import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/global.css'
// Capa administrativa: se importa DESPUÉS de global.css y todas sus clases
// van prefijadas `adm-`, así que no puede filtrarse a la web pública
// (plan 27_09_2026 §4.1, "namespacing del CSS").
import './assets/styles/admin.css'

const app = createApp(App)

app.use(router)
app.mount('#app')
